import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #414A56;
  width: 100vw;
  height: 100vh;
`;
